import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import type { JSX } from 'react';

interface PageTitleProps {
  title: string;
  description?: string;
}

export const usePageTitle = ({ title, description }: PageTitleProps): JSX.Element => {
  useEffect(() => {
    document.title = title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    if (description) {
      metaDescription.setAttribute('content', description);
    }
  }, [title, description]);

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}; 